<template>
    <div id="Home">
        <topHead></topHead>
        <indexLoginBottomHead  v-if="dataList.indexOf($route.path)>-1"> </indexLoginBottomHead>
        <noSearchHeaderBottom v-else></noSearchHeaderBottom>
        <router-view />
        <vfooter></vfooter>
<!--        <footerCopy></footerCopy>-->
    </div>
</template>

<script>
import vfooter from "@/components/common/Footer";
import topHead from "@/components/common/topHead";
import indexLoginBottomHead from "@/components/common/indexLoginBottomHead";
import noSearchHeaderBottom from "@/components/common/noSearchHeaderBottom";
import footerCopy from "@/components/common/footerCopy";

export default {
    name: "Home",
    data() {
        return {
            dataList:['/Index','/login','/index','/searchList'],
        };
    },
    components: {
        topHead: topHead,
        indexLoginBottomHead:indexLoginBottomHead,
        noSearchHeaderBottom:noSearchHeaderBottom,
        vfooter: vfooter,
        footerCopy:footerCopy,
    },
    created() {
        // console.log(this.$route.path);
    }
};
</script>

<style>
.bottomW{
    background-color: #fbfbfb;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue